<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="12"
            class="text-right"
          >
            <b-button
              variant="primary"
              @click="openModal(null)"
            >
              <feather-icon icon="PlusIcon" />
              Oluştur
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <template v-if="dataList.length > 0">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(name)="data">
            {{ data.item.name }}
            <div class="text-muted font-small-2">
              {{ data.item.email }}
            </div>
            <div class="text-muted font-small-2">
              {{ data.item.phone }}
            </div>
          </template>
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status === '1'"
              variant="light-primary"
            >
              Aktif
            </b-badge>
            <b-badge
              v-else
              variant="light-danger"
            >
              Pasif
            </b-badge>
          </template>
          <template #cell(control)="data">
            <div class="d-flex justify-content-between align-items-center">
              <b-button
                variant="primary"
                size="sm"
                @click="openModal(data.item.id)"
              >
                <FeatherIcon icon="EditIcon" />
                Güncelle
              </b-button>
              <b-button
                variant="danger"
                size="sm"
                @click="removeData(data.item.id)"
              >
                <FeatherIcon icon="TrashIcon" />
                Sil
              </b-button>
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <b-alert
        v-else
        show
        variant="info"
        class="m-2"
      >
        <div class="alert-body text-center">
          <FeatherIcon icon="InfoIcon" />
          Kullanıcı bulunamadı.
        </div>
      </b-alert>
    </b-card>
    <b-modal
      v-model="modalStatus"
      size="lg"
      title="Kullanıcı Hesabı"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
    >
      <validation-observer ref="userRules">
        <dr-user-form :save-data="submitForm" />
      </validation-observer>
    </b-modal>
  </div>
</template>
<script>
import {
  BCard, BCol, BRow, BCardBody, BCardFooter, BPagination, BTable, BButton, BAlert, BBadge, BModal,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DrUserForm from '@/views/Admin/Licenses/AppUsers/DrUserForm.vue'
import { ValidationObserver } from 'vee-validate'

const tableName = 'users'

export default {
  name: 'DrUserList',
  components: {
    BAlert,
    BCard,
    BCol,
    BRow,
    BCardBody,
    BCardFooter,
    BPagination,
    BTable,
    BButton,
    BBadge,
    BModal,
    DrUserForm,
    ValidationObserver,
  },
  data() {
    return {
      modalStatus: false,
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'name',
          label: 'Adı Soyadı',
        },
        {
          key: 'user_type',
          label: 'Kullanıcı Yetkisi',
          thClass: 'width-100 text-nowrap',
        },
        {
          key: 'status',
          label: 'Durum',
          thClass: 'width-100 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thStyle: 'width: 230px',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.name AS name`,
          `${tableName}.email AS email`,
          `${tableName}.status AS status`,
          `${tableName}.id_user_types AS id_user_types`,
          'user_types.title AS user_type',
        ],
        where: {
          'users.id_licenses': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['drUsers/dataItem']
    },
    dataList() {
      return this.$store.getters['drUsers/dataList']
    },
    dataCounts() {
      return this.$store.getters['drUsers/dataCounts']
    },
    saveData() {
      return this.$store.getters['drUsers/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
        this.modalStatus = false
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    openModal(id = null) {
      if (id) {
        this.$store.dispatch('drUsers/getDataItem', id)
          .then(response => {
            if (response.id) {
              this.modalStatus = true
            }
          })
      } else {
        this.$store.commit('drUsers/RESET_DATA_ITEM')
        this.modalStatus = true
      }
    },
    getDataList() {
      this.$store.dispatch('drUsers/getDataList', this.dataQuery)
    },
    submitForm() {
      this.dataItem.id_licenses = this.$route.params.id
      this.$refs.userRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('drUsers/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('drUsers/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
